import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';

const PageTracker: React.FC = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Track page view on route change
    const getPageName = (pathname: string): string => {
      // Map pathnames to readable page names
      const pageNameMap: Record<string, string> = {
        '/': 'Dashboard',
        '/profile': 'Profile',
        '/subscription': 'Subscription',
        '/visa/global-talent-visa': 'Global Talent Visa',
        '/visa/global-talent-visa/chat': 'Global Talent Visa Chat',
        '/visa/personal-statement': 'Personal Statement Generator',
        '/visa/tourist-visa': 'Tourist Visa',
        '/visa/tourist-visa/chat': 'Tourist Visa Chat',
        '/auth/login': 'Login',
        '/auth/register': 'Register',
        '/auth/forgot-password': 'Forgot Password',
      };

      // Return mapped name or clean up the pathname
      return pageNameMap[pathname] || pathname.replace(/^\//, '').replace(/-/g, ' ').replace(/\//g, ' > ');
    };

    const pageName = getPageName(location.pathname);
    
    // Track the page view
    trackPageView(pageName, {
      page_path: location.pathname,
      page_search: location.search,
    });
  }, [location, trackPageView]);

  // This component doesn't render anything
  return null;
};

export default PageTracker; 